import { Chain } from './types';

const KEY_CHAIN_ID = 'CHAIN_ID';

export const saveChainIdToLocalStorage = (chainId: string) => {
  localStorage.setItem(KEY_CHAIN_ID, chainId);
};

export const getChainIdFromLocalStorage = (): string | null => {
  return localStorage.getItem(KEY_CHAIN_ID);
};

export const removeChainIdFromLocalStorage = () => {
  localStorage.removeItem(KEY_CHAIN_ID);
};

export const getCurrentChain = (currentChainId: string | null, chains: Chain[]) => {
  if (chains.length === 0) {
    return;
  }

  const defaultChain = chains[0];

  if (currentChainId) {
    const selectedChain = chains.find((chain) => chain.id === currentChainId);
    return selectedChain ?? defaultChain;
  }

  return defaultChain;
};
